import { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import DisbursalReporting from "./DisbursalReporting";
import PayoutReporting from "./PayoutReporting";
import EMIReport from "./EMIReport";
import PaymentsReporting from "./PaymentsReporting";
import PanReport from "./PanReport";
import PennyReport from "./PennyReport";
import OkycReport from "./OkycReport";
import BankingReport from "./BankingReport";
import CibilReport from "./CibilReport";
import CibilReportMIS from "./CibilReportMIS"
import FIPReporting from "./FIPReporting";
import PIFReporting from "./PIFReporting";
import FeeReporting from "./FeeReporting";
import FeePIFReporting from "./FeePIFReporting";
import ChargesReporting from "./ChargesReporting"
import ExtraAmountReporting from "./ExtraAmountReporting";
import LoanReporting from "./LoanReporting";
import CustomerReporting from "./CustomerReporting";
import NashPresentationReporting from "./NashPresentationReporting";
import LoanCardReporting from "./LoanCardReporting";
import LoanMasterReporting from "./LoanMasterReporting";
import OverdueReporting from "./OverdueReporting";
import BureauReporting from "./BureauReporting"; // Add this line


const Reporting = () => {
  const [reports, setReports] = useState([
    {
      title: "Disbursal Report",
      subItems: ["Disbursal"], // Initially only Disbursal
    },
    // {
    //   title: "EMI Report",
    //   subItems: ["EMI Report"], // Added multiple subtypes
    // },
    {
      title: "OVER DUE Report",
      subItems: ["Over Due Report"], // Added multiple subtypes
    },
   {
  title: "EMI Schedule Report",
  subItems: ["FIP Report", "PIF Report"],
},

    {
      title: "Payments Report",
      subItems: ["Payments"],
    },
 

    {
      title: "Third Party Report",
      subItems: ["Pan" , "Penny" , "Okyc" , "Banking"],
    },
    
     { 
  title: "Bureau Report",
  subItems: ["Bureau Report"], // subItems can be the same as title for simplicity
},

     {
      title: "Cibil Transaction",
      subItems: ["Cibil"],
    },
     {
      title: "Bureau MIS Report",
      subItems: ["CibilMIS"],
    },
     
     
 
   {
  title: "Penal Interest Report",
  subItems: ["Fee Report", "Fee PIF Report"], // Use consistent naming
},

//  {
//       title: "Charges Report",
//       subItems: ["Charges Report", "Extra Amount"],
//     },


    {
      title: "Loans Report",
      subItems: ["Loans"],
    },
    {
      title: "Customer Report",
      subItems: ["Customers"],
    },
    {
      title: "E-Mandate Report",
      subItems: ["Recurring "],
    },
     {
    title: "Loan Card Report",
    subItems: ["Loan Card Report"],   
  },
  {
  title: "Loan Master Report",
  subItems: ["Loan Master Report"],
}

]);

  const [expandedReport, setExpandedReport] = useState(null);
  const [selectedMainReport, setSelectedMainReport] = useState(null);
  const [selectedSubReport, setSelectedSubReport] = useState(null);

  const handleExpand = (report) => {
    setSelectedMainReport(report.title);
    setSelectedSubReport(null);

    // Example logic to add "Payout" dynamically for Disbursal
    if (report.title === "Disbursal Report" && report.subItems.length === 1) {
      const updatedReports = reports.map((r) =>
        r.title === "Disbursal Report"
          ? { ...r, subItems: [...r.subItems, "Payout"] }
          : r
      );
      setReports(updatedReports);
    }
    setExpandedReport(expandedReport === report.title ? null : report.title);
  };

  const renderReportContent = () => {
    if (!selectedMainReport && !selectedSubReport) {
      return (
        <p style={{ fontSize: "18px", color: "#6c757d" }}>
          Please select a report to view.
        </p>
      );
    }

    if (selectedMainReport && !selectedSubReport) {
      return (
        <p style={{ fontSize: "18px", color: "#6c757d" }}>
          You selected <strong>{selectedMainReport}</strong>. Please choose a sub-report.
        </p>
      );
    }

    switch (selectedSubReport) {
      case "Disbursal":
        return <DisbursalReporting />;
      case "Payout":
        return <PayoutReporting />;
      case "EMI Report":
        return <EMIReport />;
      case "Payments":
        return <PaymentsReporting />;
       case "Pan":
        return <PanReport />;
      case "Penny":
        return <PennyReport />;
      case "Okyc":
        return <OkycReport />;
         case "Banking":
        return <BankingReport />;
        case "Bureau Report":
  return <BureauReporting />;

         case "Cibil":
        return <CibilReport />;

         case "CibilMIS":
        return <CibilReportMIS />;

         case "FIP Report":
     return <FIPReporting />;
       case "PIF Report":
        return <PIFReporting />;
   case "Fee Report":
  return <FeeReporting />;
case "Fee PIF Report":
  return <FeePIFReporting />;
  case "Charges Report":
  return <ChargesReporting />;
   case "Extra Amount":
  return <ExtraAmountReporting />
      case "Loans":
        return <LoanReporting />;
      case "Customers":
        return <CustomerReporting />;

        case "Loan Card Report":
  return <LoanCardReporting />;
  case "Over Due Report":
  return <OverdueReporting />;


 case "Loan Master Report":
  return <LoanMasterReporting />;

      case "Nash Presentation":
        return <NashPresentationReporting />;
      default:
        return (
          <p style={{ fontSize: "16px", color: "#495057" }}>
            Content for <strong>{selectedSubReport}</strong> is coming soon.
          </p>
        );
    }
  };

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-4 pt-md-7 mb-4">
        <Container fluid>
          <Row>
            <Col>
              <h1 className="text-white">Reporting Dashboard</h1>
            </Col>
          </Row>
        </Container>
      </div>

      <Container fluid>
        <Row>
          {/* Sidebar */}
          <Col md="3">
            <div
              style={{
                backgroundColor: "#f1f3f5",
                border: "1px solid #dee2e6",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "500px",
                overflowY: "auto",
              }}
            >
              {reports.map((report, index) => (
                <div key={index} style={{ marginBottom: "10px" }}>
                  <div
                    onClick={() => handleExpand(report)}
                    style={{
                      padding: "10px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      backgroundColor:
                        expandedReport === report.title ? "#5e72e4" : "transparent",
                      color: expandedReport === report.title ? "#fff" : "#000",
                      transition: "all 0.2s",
                    }}
                  >
                    <strong>{report.title}</strong>
                  </div>

                  {expandedReport === report.title && report.subItems.length > 0 && (
                    <div style={{ marginLeft: "15px", marginTop: "8px" }}>
                      {report.subItems.map((sub, subIndex) => (
                        <div
                          key={subIndex}
                        onClick={() => {
                            setSelectedSubReport(sub);
                            setSelectedMainReport(report.title); // ✅ FIX
                          }}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderRadius: "4px",
                            backgroundColor:
                              selectedSubReport === sub ? "#11cdef" : "transparent",
                            color: selectedSubReport === sub ? "#fff" : "#000",
                            marginBottom: "6px",
                          }}
                        >
                          ➤ {sub}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Col>

          {/* Content Area */}
          <Col md="9">
            <div
              style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #dee2e6",
                borderRadius: "10px",
                padding: "25px",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.05)",
              }}
            >
              <h4>{selectedSubReport || selectedMainReport || "No Report Selected"}</h4>
              {renderReportContent()}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Reporting;
